var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBelatra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "belatra 1",
    clipPath: "url(#clip0_2_18428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.9872 38.8229C55.3572 38.2439 53.5372 36.3849 52.9242 33.6149C52.6002 32.1589 52.8162 28.1609 53.2842 26.8809C53.9152 25.1629 54.7982 24.1809 56.4562 23.3739L57.8972 22.6729L63.1772 22.6199L68.4372 22.5669V25.3899H64.3302C59.5202 25.3899 58.6902 25.5299 57.8442 26.5479C57.0512 27.4779 56.8172 28.5119 56.8172 30.9139C56.8172 35.1749 57.8442 36.0869 62.5832 36.0869H64.6552V32.2299H59.9692V29.2499H68.4372L68.4012 34.1239L68.3472 38.9819L63.6632 39.0169C60.5102 39.0339 58.6532 38.9639 57.9872 38.8239V38.8229Z",
    fill: "url(#paint0_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.8281 38.9718C68.8281 38.9368 69.2061 38.0418 69.6571 36.9888C70.1071 35.9528 70.6661 34.6538 70.9001 34.1278C71.1161 33.6008 72.3051 30.8798 73.5121 28.0718C74.7201 25.2808 75.7471 22.8758 75.8011 22.7528C75.8731 22.5948 76.3951 22.5428 77.8731 22.5778L79.8371 22.6298L80.7921 24.8248C81.8181 27.1588 84.8641 34.1448 86.1071 36.9708C86.5031 37.9188 86.8461 38.7788 86.8461 38.8668C86.8461 38.9898 86.1611 39.0428 84.9181 39.0068L82.9721 38.9548L82.2511 37.1998C81.8551 36.2338 81.4581 35.3388 81.3861 35.2158C81.2781 35.0578 80.3231 35.0058 77.7461 35.0058C73.6931 35.0058 74.2161 34.7418 73.2421 37.3398L72.6481 38.9548L70.7381 39.0078C69.6931 39.0248 68.8281 39.0248 68.8281 38.9718ZM80.1781 32.0738C80.1781 31.7048 77.7651 26.0538 77.6561 26.1758C77.5301 26.3158 75.3141 31.9338 75.3141 32.1088C75.3141 32.1618 76.4141 32.1968 77.7471 32.1968C79.0801 32.1968 80.1791 32.1438 80.1791 32.0738H80.1781Z",
    fill: "url(#paint1_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.7529 38.8789C87.6829 38.8259 87.6289 35.1239 87.6289 30.6709V22.5849H92.8609L94.8829 28.5749C95.9829 31.8579 96.9579 34.6169 97.0289 34.7049C97.1189 34.7749 98.0939 32.1029 99.2289 28.7669L101.268 22.6719L103.858 22.6199L106.43 22.5669V39.0009H103.024L103.131 32.8529L103.237 26.6889L101.144 32.8009L99.0689 38.9129L97.1709 38.9659L95.2909 39.0179L93.7659 34.5129C92.9319 32.0329 91.9559 29.2209 91.6199 28.2609L90.9989 26.5139L91.1229 32.7659L91.2289 39.0009H89.5439C88.6219 39.0009 87.8059 38.9479 87.7529 38.8789Z",
    fill: "url(#paint2_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M114.388 38.8259C111.089 38.2659 109.172 35.3639 109.172 30.9759C109.189 26.6579 110.467 24.2279 113.3 23.0739C114.198 22.7069 114.595 22.6719 118.378 22.6199L122.472 22.5669V25.3819H119.535C116.219 25.3819 115.096 25.5569 114.319 26.2219C113.68 26.7629 113.162 27.8639 113.144 28.6689V29.2289H122.489L122.437 30.6789L122.385 32.1129L117.67 32.1649L112.937 32.1999L113.058 32.9519C113.231 34.1059 113.853 35.2069 114.526 35.6089C115.062 35.9239 115.528 35.9759 118.758 36.0459L122.385 36.1339L122.437 37.5839L122.489 39.0179L118.896 39.0009C116.927 38.9829 114.889 38.9129 114.388 38.8259Z",
    fill: "url(#paint3_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M125.135 37.5319V36.0459H130.07C135.217 36.0459 135.623 35.9939 136.222 35.2769C136.469 34.9799 136.521 33.8429 136.328 33.2309C136.098 32.5499 135.235 32.3749 132.133 32.3749C130.546 32.3749 128.784 32.2879 128.22 32.1829C125.717 31.7279 124.624 30.5039 124.465 27.9869C124.324 25.5039 125.118 23.8959 126.933 23.0919C127.85 22.6899 127.991 22.6719 133.648 22.6199L139.43 22.5669L139.377 24.0179L139.324 25.4689L134.248 25.5569L129.154 25.6439L128.643 26.2209C127.832 27.1129 127.955 28.5639 128.89 29.0879C129.154 29.2459 130.529 29.3499 133.243 29.4199C136.927 29.5079 137.262 29.5429 138.055 29.9099C139.553 30.6269 140.117 31.7629 140.117 33.9999C140.117 35.6799 139.888 36.5179 139.201 37.3569C137.984 38.7909 136.803 39.0179 130.211 39.0179H125.135V37.5319Z",
    fill: "url(#paint4_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.0703 8.80782V0.59082L58.8493 0.64382C65.1843 0.69582 65.2363 0.71382 66.3993 1.84982C67.2323 2.67182 67.5443 3.50982 67.5443 4.89182C67.5273 6.35982 67.1283 7.26982 66.0863 8.17882L65.3923 8.77282L66.0863 9.24482C67.1283 9.94482 67.5623 10.8878 67.5623 12.5848C67.5623 15.0148 66.6943 16.1848 64.4383 16.7798C63.6223 16.9898 62.3383 17.0418 58.2413 17.0418H53.0703V8.80782ZM62.8753 13.8078C63.5523 13.5278 63.8303 13.0038 63.8303 11.9898C63.8303 10.5388 62.8753 10.1898 59.2303 10.2588L56.6273 10.3118L56.5753 11.9548C56.5583 12.8638 56.5583 13.7028 56.6103 13.8428C56.7493 14.1928 62.0603 14.1578 62.8753 13.8078ZM62.7713 7.05982C64.2293 6.55282 64.1423 4.19282 62.6503 3.75582C62.2683 3.63282 60.9143 3.58082 59.3173 3.61582L56.6273 3.66782L56.5753 5.20682C56.5403 6.06282 56.5583 6.86682 56.6103 7.00682C56.6803 7.19982 57.2353 7.25182 59.4563 7.25182C61.0363 7.25182 62.4593 7.16482 62.7713 7.05982Z",
    fill: "url(#paint5_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.47 2.49285L1.31004 11.7238C1.08004 11.9548 0.983037 12.2188 0.983037 12.5148C0.983037 12.8118 1.08104 13.1088 1.31004 13.3398L10.472 22.5708C10.668 22.7688 10.962 22.9008 11.257 22.9008C11.552 22.9008 11.847 22.7688 12.075 22.5708L21.237 13.3398C21.3437 13.2309 21.4276 13.1019 21.4839 12.9603C21.5402 12.8186 21.5678 12.6672 21.565 12.5148C21.565 12.2188 21.466 11.9548 21.237 11.7248L12.075 2.49285C11.9677 2.38585 11.8401 2.30151 11.6995 2.24482C11.559 2.18813 11.4085 2.16025 11.257 2.16285C11.1105 2.16059 10.9651 2.18876 10.8299 2.24556C10.6948 2.30236 10.573 2.38656 10.472 2.49285H10.47ZM12.761 1.76785L16.426 5.49285C19.24 3.28385 21.334 1.99785 21.334 1.99785L21.531 1.86685L21.694 1.99785C21.76 2.03085 41.36 14.3948 41.36 26.1978C41.36 29.0978 40.215 31.7028 38.415 33.5828C36.583 35.4948 34.063 36.6488 31.282 36.6488C29.2408 36.6496 27.2421 36.0659 25.522 34.9668C24.2614 34.1898 23.1889 33.1426 22.382 31.9008C23.265 38.6268 30.398 39.0218 31.216 39.0218H31.282V39.6818H11.78V39.0218H11.845C12.663 39.0218 19.764 38.6269 20.68 31.9018C19.8549 33.1286 18.7857 34.172 17.539 34.9668C15.8171 36.0617 13.8196 36.645 11.779 36.6488C8.99904 36.6488 6.47904 35.4948 4.64604 33.5828C2.81404 31.7028 1.70204 29.0989 1.70204 26.1978C1.70204 24.7468 1.99604 23.2628 2.52004 21.7799C2.97804 20.4608 3.66504 19.1748 4.45004 17.8898L0.590037 14.0308C0.207773 13.6189 -0.00320054 13.0768 3.67107e-05 12.5148C3.67107e-05 11.9878 0.196037 11.4268 0.589037 11.0318L9.78404 1.76785C10.178 1.38471 10.7065 1.17143 11.256 1.17385C11.812 1.17385 12.336 1.37185 12.761 1.76785Z",
    fill: "url(#paint6_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M74.3639 16.8668C72.5839 16.5178 70.8209 15.1568 69.9659 13.4618C69.3789 12.3098 69.1289 10.9118 69.1289 8.85184C69.1469 4.85184 70.3399 2.51184 73.0289 1.25484L74.2029 0.713844L78.5309 0.659844L82.8389 0.589844V3.36684L79.3319 3.45384C76.2159 3.52384 75.7179 3.57684 75.0949 3.89084C74.7029 4.10084 74.2399 4.39684 74.0799 4.58884C73.7059 4.99084 73.2249 6.26584 73.2249 6.84184V7.26184H82.8389V10.1428L79.0649 10.0908C76.9819 10.0728 74.8099 10.0908 74.2579 10.1608L73.2249 10.2648V10.9808C73.2249 11.9768 73.8309 13.1108 74.6139 13.5828C75.2369 13.9678 75.4689 13.9848 79.0649 14.0368L82.8389 14.0898V17.0408L78.9759 17.0238C76.8399 17.0058 74.7559 16.9358 74.3649 16.8668H74.3639Z",
    fill: "url(#paint7_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M89.8411 16.8668C88.2341 16.5348 86.8011 15.3808 86.0851 13.8068C85.7001 12.9508 85.6831 12.7768 85.6311 6.77982L85.5781 0.60882H89.0721L89.1251 6.42982C89.1771 11.9018 89.1951 12.2698 89.5271 12.8458C90.2081 13.9828 90.7321 14.1578 94.0341 14.2098L96.9521 14.2798V15.5208L96.9691 16.7798L97.4061 15.7308C97.6511 15.1538 98.7511 12.5668 99.8521 9.96082C100.952 7.37382 102.298 4.19282 102.839 2.91582L103.835 0.59082L105.757 0.64382L107.661 0.69582L108.744 3.23082C109.338 4.62982 110.876 8.23082 112.169 11.2548C113.461 14.2798 114.545 16.8318 114.562 16.9018C114.597 16.9718 113.741 17.0418 112.64 17.0418H110.666L109.95 15.1538L109.234 13.2838L105.652 13.2308L102.053 13.1958L101.372 15.0658L100.673 16.9548L95.6231 16.9718C92.8461 16.9898 90.2431 16.9368 89.8411 16.8668ZM106.683 10.1018L107.941 10.0138L107.626 9.19282C105.739 4.33282 105.635 4.08782 105.477 4.34982C105.39 4.48982 104.866 5.83582 104.307 7.32182C103.643 9.08782 103.346 10.0668 103.486 10.1188C103.748 10.2238 105.18 10.2238 106.683 10.1018Z",
    fill: "url(#paint8_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M117.31 10.3118V3.57982L114.627 3.52682L111.926 3.47482L111.873 2.04082L111.82 0.59082H126.313V1.98982C126.313 2.98582 126.242 3.38782 126.101 3.40582C125.977 3.42282 125.713 3.44082 125.518 3.45782C124.713 3.49591 123.907 3.51925 123.1 3.52782L121.017 3.56282L120.982 10.2588L120.929 16.9368L119.128 16.9898L117.31 17.0418V10.3118Z",
    fill: "url(#paint9_linear_2_18428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M127.883 8.80782V0.59082H132.969C138.421 0.59082 139.167 0.67882 140.4 1.50082C140.747 1.74482 141.181 2.30482 141.476 2.84582C141.893 3.68582 141.945 3.99982 141.945 5.41582C141.945 6.60582 141.858 7.23482 141.615 7.79382C141.233 8.70382 140.053 9.82182 139.341 9.97882C139.046 10.0318 138.82 10.1018 138.82 10.1538C138.82 10.3118 142.553 16.4998 142.657 16.4998C142.709 16.4998 143.803 13.9998 145.07 10.9578C146.355 7.89782 147.848 4.33182 148.404 3.03782L149.411 0.67782L151.303 0.62582C152.709 0.59082 153.213 0.64382 153.282 0.80082C153.334 0.92282 154.862 4.55982 156.685 8.87782C158.508 13.1778 160.001 16.7798 160.001 16.8678C160.001 16.9548 159.168 17.0248 158.126 17.0248H156.268L155.487 15.0848L154.706 13.1438H151.251C149.359 13.1608 147.744 13.2138 147.674 13.3008C147.605 13.3708 147.431 13.7908 147.275 14.2268C147.119 14.6648 146.824 15.4688 146.633 16.0278L146.268 17.0248H138.872L137.101 13.7898L135.313 10.5548H131.355L131.32 13.7548L131.268 16.9358L129.584 16.9888L127.883 17.0408V8.80782ZM153.334 10.0488C153.473 9.97882 153.143 8.94782 152.345 6.97182C151.216 4.08782 151.164 4.01782 150.973 4.52482C150.852 4.82182 150.47 5.83582 150.105 6.79782C149.74 7.75882 149.306 8.84282 149.168 9.19282C149.011 9.55982 148.89 9.87382 148.89 9.92682C148.89 10.1188 153.022 10.2418 153.334 10.0488ZM136.997 7.40882C138.317 7.11182 138.872 5.73082 138.213 4.45482C137.831 3.70282 137.171 3.56282 134.115 3.56282H131.355V7.58382H133.837C135.192 7.58382 136.615 7.49682 136.997 7.40882Z",
    fill: "url(#paint10_linear_2_18428)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_18428",
    x1: 60.6032,
    y1: 22.5669,
    x2: 60.6032,
    y2: 39.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_18428",
    x1: 77.8371,
    y1: 22.5668,
    x2: 77.8371,
    y2: 39.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_18428",
    x1: 97.0289,
    y1: 22.5669,
    x2: 97.0289,
    y2: 39.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_18428",
    x1: 115.83,
    y1: 22.5669,
    x2: 115.83,
    y2: 39.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_18428",
    x1: 132.283,
    y1: 22.5669,
    x2: 132.283,
    y2: 39.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_18428",
    x1: 60.3153,
    y1: 0.59082,
    x2: 60.3153,
    y2: 17.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_18428",
    x1: 20.68,
    y1: 1.17385,
    x2: 20.68,
    y2: 39.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_18428",
    x1: 75.9839,
    y1: 0.590844,
    x2: 75.9839,
    y2: 17.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_18428",
    x1: 100.071,
    y1: 0.59082,
    x2: 100.071,
    y2: 17.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_18428",
    x1: 119.067,
    y1: 0.59082,
    x2: 119.067,
    y2: 17.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_18428",
    x1: 143.942,
    y1: 0.59082,
    x2: 143.942,
    y2: 17.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2998FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelatra);
export default __webpack_public_path__ + "static/media/belatra.07e5dcfe180222fe69e9926971598288.svg";
export { ForwardRef as ReactComponent };